<template>
    <el-form
        :model="signInForm"
        label-width="160px"
        class="receipt-signIn-form"
    >
        <el-row :gutter="20">
            <el-col :span="8">
                <el-form-item label="运输单号：">
                    <div class="inputValue">
                        {{ signInForm.taskNo }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="物流单号：">
                    <div class="inputValue">
                        {{ signInForm.orderNo }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="客户订单号：">
                    <div class="inputValue">
                        {{ signInForm.customerOrderNo }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="签收人：">
                    <div class="inputValue">
                        {{ signInForm.signContact }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="总数量：">
                    <div class="inputValue">
                        {{ signInForm.totalQty }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="发车单号：">
                    <div class="inputValue">
                        {{ signInForm.dispatchNo }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="到达时间：">
                    <div class="inputValue">
                        {{ signInForm.actualArriveDate }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="总重量(kg)：">
                    <div class="inputValue">
                        {{ signInForm.totalGrossWeight }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="汇总：">
                    <div class="inputValue">
                        <el-tooltip :content="content" placement="top">
                            <span>
                                实发：{{ signInForm.realDeliverCount }}
                                / 实收：{{ signInForm.realReceiveCount }}
                                / 异常：{{ signInForm.abnormalCount }}
                            </span>
                        </el-tooltip>
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="签收时间：">
                    <div class="inputValue">
                        {{ signInForm.signTime }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="总体积(m³)：">
                    <div class="inputValue">
                        {{ signInForm.totalVolume }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8">
                <el-form-item label="司机 / 车牌号：">
                    <div class="inputValue">
                        {{ `${signInForm.driver} / ${signInForm.vehicleCard}` }}
                    </div>
                </el-form-item>
            </el-col>

            <el-col :span="8" v-if="isShowFlag">
                <div
                    style="height: 40px; line-height: 40px; padding-left: 28px"
                >
                    <el-checkbox
                        v-model="signInForm.upstairsCharge"
                        :disabled="isChargeEditOk"
                        true-label="Y"
                        false-label=""
                        @change="changeFlag"
                        >上楼费标识</el-checkbox>
                </div>
            </el-col>

            <el-col :span="8" v-if="isShowFlag">
                <div
                    style="height: 40px; line-height: 40px; padding-left: 20px"
                >
                    <el-checkbox
                        v-model="signInForm.unloadCharge"
                        :disabled="isChargeEditOk"
                        true-label="Y"
                        false-label=""
                        @change="changeFlag"
                        >卸货费标识</el-checkbox>
                </div>
            </el-col>

            <el-col v-if="isShowSN" :span="8" >
                <el-form-item label="出库商品编码和SN码：" >
                    <el-tooltip effect="dark" :content="getTooltipContent('custItemCodeSerialNumber')" placement="top">
                        <div class="truncate" @dblclick="handleCopy('custItemCodeSerialNumber')">
                            {{ (signInForm.custItemCodeSerialNumber || [])[0] || '' }}
                        </div>
                    </el-tooltip>
                </el-form-item>
            </el-col>

        </el-row>
    </el-form>
</template>
<script>
import { sum, toNum, roundDecimalPlaces } from './util.js';
import { copyText2 } from '@/modules/transport/otp/utils/commonFun.js';
export default {
    name: 'signInForm',
    props: {
        goodsList: {
            type: Array,
            default () {
                return [];
            }
        },
        viewStatus: {
            type: String,
            default () {
                return '1';
            }
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        isChargeEdit: {
            type: Number,
            default () {
                return 0;
            }
        }
    },
    data () {
        return {
            content: '',
            signInForm: {
                taskNo: '', // 运输单号
                dispatchNo: '', // 发车单号
                customerOrderNo: '', // 客户订单号
                orderNo: '', // 物流单号
                realDeliverCountAll: '', // 汇总
                signContact: '', // 签收人
                signTime: '', // 签收时间
                totalGrossWeight: '', // 总重量
                totalVolume: '', // 总体积
                totalQty: '', // 总数量
                driver: '', // 司机
                vehicleCard: '', // 车牌号
                actualArriveDate: '', // 到达时间
                realDeliverCount: 0,
                realReceiveCount: 0,
                abnormalCount: 0,
                unloadCharge: '', // 卸货费标识
                upstairsCharge: '', // 上楼费标识
                custItemCodeSerialNumber: [] // 出库商品编码和SN码
            }
        };
    },
    computed: {
        // 是否串点计费为是 且 出入库类型： 出库单、纯运输，才显示标识
        isShowFlag () {
            return +this.rowData.dmsFlag === 1 && ['OUT', 'YS'].includes(this.rowData.inOutType);
        },
        // 卸货上楼标识是否禁用
        isChargeEditOk () {
            return this.isChargeEdit === 0;
        },
        /**
         * 订单来源：菜鸟和美云销
         * 配送方式：配送、直配
         * 高端服务：国补订单、省补订单
         */
         isShowSN() {
            const { deliveryType, sourceSystem, orderTypeExt } = this.rowData || {};
            if (!['CAINIAO', 'OFC'].includes(sourceSystem)) return false;
            if (!['DELIVERY', 'WAREHOUSEMATCHING'].includes(deliveryType)) return false;
            return ['GD_SUBSIDIES', 'STATE_SUBSIDIES'].includes(orderTypeExt);
        }
    },
    watch: {
        goodsList: {
            immediate: true,
            deep: true,
            handler (val) {
                let realDeliveNum = 0;
                let realReceiveNum = 0;
                let abnormalNum = 0;
                // 复制数据，避免数据污染，并判断是否存在总计行，如果有则删除
                const copyGoodsList = JSON.parse(JSON.stringify(val));
                if (copyGoodsList[copyGoodsList.length - 1] && copyGoodsList[copyGoodsList.length - 1].isTotalRow) {
                    copyGoodsList.pop();
                }
                if (this.viewStatus === '1') {
                    copyGoodsList.forEach(e => {
                        if (e) {
                            realDeliveNum += sum([
                                e.rejectQty,
                                e.realReceive,
                                e.stockoutCount,
                                e.mildewPolluteCount,
                                e.packageDamagedCount
                            ]);
                            realReceiveNum += sum([
                                e.realReceive,
                                e.mildewPolluteCount,
                                e.packageDamagedCount
                            ]);
                            abnormalNum += sum([
                                e.rejectQty,
                                e.stockoutCount,
                                e.mildewPolluteCount,
                                e.packageDamagedCount
                            ]);
                        }
                    });
                }
                if (this.viewStatus === '2') {
                    copyGoodsList.forEach(e => {
                        if (e) {
                            realDeliveNum += toNum(e.realDeliverCount);
                            realReceiveNum += sum([
                                e.goodSignQty,
                                e.machinedmgSignQty,
                                e.packingdmgSignQty,
                                e.fittingshortSignQty
                            ]);
                            abnormalNum += sum([
                                e.shortQty,
                                e.goodRejectQty,
                                e.performRejectQty,
                                e.machinedmgSignQty,
                                e.packingdmgSignQty,
                                e.fittingshortSignQty,
                                e.packingdmgRejectQty,
                                e.machinedmgRejectQty,
                                e.fittingshortRejectQty
                            ]);
                        }
                    });
                }
                if (this.viewStatus === '3') {
                    copyGoodsList.forEach(e => {
                        if (e) {
                            realDeliveNum += toNum(e.realDeliverCount);
                            realReceiveNum += sum([
                                e.goodSignQty,
                                e.packingdmgSignQty
                            ]);
                            abnormalNum += sum([
                                e.shortQty,
                                e.goodRejectQty,
                                e.packingdmgSignQty,
                                e.packingdmgRejectQty,
                                e.machinedmgRejectQty
                            ]);
                        }
                    });
                }
                if (this.viewStatus === '4') {
                    copyGoodsList.forEach(e => {
                        if (e) {
                            realDeliveNum += toNum(e.realDeliverCount);
                            realReceiveNum += sum([
                                e.goodSignQty,
                                e.packingdmgSignQty,
                                e.machinedmgSignQty
                            ]);
                            abnormalNum += sum([
                                e.shortQty,
                                e.goodRejectQty,
                                e.performRejectQty,
                                e.packingdmgSignQty,
                                e.machinedmgSignQty,
                                e.packingdmgRejectQty,
                                e.machinedmgRejectQty,
                                e.fittingshortRejectQty
                            ]);
                        }
                    });
                }
                this.signInForm.realDeliverCount = roundDecimalPlaces(realDeliveNum);
                this.signInForm.realReceiveCount = roundDecimalPlaces(realReceiveNum);
                this.signInForm.abnormalCount = roundDecimalPlaces(abnormalNum);
                this.content = '实发：' + roundDecimalPlaces(realDeliveNum) + ' / 实收：' + roundDecimalPlaces(realReceiveNum) + ' / 异常：' + roundDecimalPlaces(abnormalNum);
            }
        }
    },
    methods: {
        /**
         * @description 初始化回单签收表单字段值
         * @param {Object} data 接口返回的回单数据
         */
        initFormData (data) {
            Object.keys(this.signInForm).forEach(k => {
                this.signInForm[k] = data[k] || '';
            });
        },
        // 修改卸货上楼标识
        changeFlag () {
            this.$emit('changeFlag', this.signInForm);
        },
        // 获取tip内容
        getTooltipContent(prop) {
            const strategy = {
                custItemCodeSerialNumber: () => (this.signInForm.custItemCodeSerialNumber || []).join(' , ')
            };
            const handle = strategy[prop];
            return handle ? handle() : '';
        },
        // 复制
        handleCopy(prop) {
            const strategy = {
                custItemCodeSerialNumber: () => {
                    const content = (this.signInForm.custItemCodeSerialNumber || []).join(' , ');
                    if (content) {
                        copyText2.call(this, content);
                    }
                }
            };
            const handle = strategy[prop];
            return handle ? handle() : '';
        }
    }
};
</script>
<style lang="less">
.receipt-signIn-form {
    .el-form-item__content {
        line-height: 35px;
    }

    .el-form-item__label {
        height: 35px;
        line-height: 35px;
    }
    .truncate {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

}
</style>
